import React from "react";

/**
 * Which offer the Workstation is about.
 *
 * SHELL.md puts the live object in the appbar's left slot. That slot belongs to
 * `CipherShell`, frozen tonight with no owner, so the picker renders at the top
 * of the area instead. The selection lives in the URL (`?offer=`), so moving
 * this into the appbar later is a move of one component rather than a rewrite —
 * nothing reads the selection from here.
 *
 * A native `<select>` on purpose. The offer list is unbounded and a combobox
 * built tonight would be a taste decision (R7) and an accessibility surface
 * nobody has time to get right; the platform control is keyboard-complete,
 * screen-reader-complete and free.
 */
export default function OfferPicker({ offers, selectedId, onSelect, error }) {
  if (error) {
    return (
      <div className="ws-picker state state-error" role="status">
        Could not read the offer list: {error}
      </div>
    );
  }
  if (offers === null) {
    return (
      <div className="ws-picker" aria-busy="true">
        <span className="skeleton ws-skeleton-line" />
      </div>
    );
  }
  if (offers.length === 0) {
    return (
      <div className="ws-picker state ws-state" role="status">
        No offers yet. The Workstation is about one offer at a time, and there is
        not one to be about — create one in Settings → Offers &amp; Campaigns.
      </div>
    );
  }

  return (
    <div className="ws-picker">
      <label className="ws-picker-label" htmlFor="ws-offer-select">
        Offer
      </label>
      <select
        id="ws-offer-select"
        className="input ws-picker-select"
        value={selectedId || ""}
        onChange={(e) => onSelect(e.target.value)}
        data-testid="ws-offer-picker"
      >
        <option value="">Select an offer…</option>
        {offers.map((o) => (
          <option key={o.offer_id} value={o.offer_id}>
            {o.name || o.offer_id}
            {o.vertical ? ` · ${o.vertical}` : ""}
          </option>
        ))}
      </select>
    </div>
  );
}
